import { Component } from '@angular/core';
import { UtilService } from '../../services/util.service';
import { ConstantService } from '../../services/constant.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule, DatePipe } from '@angular/common';
import { EncryptionService } from '../../services/encryption.service';
import { CookieService } from 'ngx-cookie-service';
import { FormControl, Validators } from '@angular/forms';
import { MaterialModule } from '../../material.module';
import { CommonService } from '../../services/common.service';
import { IncomeDetailsService } from '../../services/income-details.service';
import { FetchDormantStatusReq, GetClientModificationStatusReq, PushSegment2Req, PushSegmentReq, SegmentDetailsReq, UpdateIncomeRangeReq } from '../../models/request.model';
import { environment } from '../../../environments/environment';
import { UserSessionService } from '../../services/user-session.service';
import { DerivativeDetailsService } from '../../services/derivative-details.service';
import { clevertapPush } from '../../services/modification-common.service';
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';





@Component({
  selector: 'app-income-details',
  imports: [MaterialModule, CommonModule],
  templateUrl: './income-details.component.html',
  styleUrl: './income-details.component.less'
})
export class IncomeDetailsComponent {

  appSource! :string;
  subSource! :string;
  ipAddress! : string;
  clientCode! : string;
  salarySlab: any;
  dpholding: number = 0;
  btnText: string = 'Continue';
  annualIncome = new FormControl(2, Validators.required);
  errorCheck:boolean = false;
  dematAccountNo!: string;
  btnLoader:boolean = false;
  clientStatus: string = 'A';
  errorMsg!: string;

  constructor(
    private utilService: UtilService,
    private constantService: ConstantService,
    private datePipe: DatePipe,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private encryptionService: EncryptionService,
    private cookieService: CookieService,
    private commonService : CommonService,
    private incomeDetailsService : IncomeDetailsService,
    private userSessionService : UserSessionService,
    private derivativeDetailsService : DerivativeDetailsService,
    private _snackbar  : MatSnackBar

) {
  this.appSource = localStorage.getItem(this.constantService.localStorageElement.appSource) || '';
  this.subSource = localStorage.getItem(this.constantService.localStorageElement.subSource) || '';
  this.clientCode = localStorage.getItem(this.constantService.localStorageElement.clientCode) || '';
}

  annualIncomeList = [
     {
        id: 1,
        ammout: 'Below 1 Lac',
        values: 'Below 1 Lac'
    },
    {
        id: 2,
        ammout: '1 - 5 Lac',
        values: '1Lac-5Lac'
    },
    {
        id: 3,
        ammout: '5 - 10 Lac',
        values: '5Lac-10Lac'
    },
    {
        id: 4,
        ammout: '10 - 25 Lac',
        values: '10Lac-25Lac'
    },
    {
        id: 5,
        ammout: '25 - 50 Lac',
        values: '25Lac-50Lac'
    },
    {
        id: 6,
        ammout: '50 Lac - 1 Cr',
        values: '50Lac-1Cr'
    },
    {
        id: 7,
        ammout: 'More than 1 Cr',
        values: 'Above 1Cr'
    }
  ];

 

  async ngOnInit() {
     const event = {
          value : this.annualIncome.value
      }
      this.getSalarySlab(event);
    await this.segmentDetails();
      
  
     
  }

 

  getPushSegment() {
      const  appSource = 'CLIENTWEB'
      const todayDt = this.datePipe.transform(new Date(), this.constantService.checksumDateFormate);
      const parameter = this.userSessionService.getUserSessionData().clientCode + appSource + this.userSessionService.getUserSessionData().ip+ todayDt;
      const checkSumValue = this.utilService?.GenerateCheckSum(parameter,appSource);
      const pushSegmentReq : PushSegmentReq = {
          head: {
              ipAddress: this.userSessionService.getUserSessionData().ip,
              appSource: appSource,
              checkSumValue: checkSumValue
          },
          body: {
              typeOfModification: '1',
              clientCode: this.userSessionService.getUserSessionData().clientCode,
              dpAccountNo: this.dematAccountNo,
              incomeSlab: this.salarySlab?.values,
              proofCode1: '22',
              proofCode2: '0',
              img_Proof1: '',
              img_Proof2: '',
              imgType1: '',
              imgType2: ''
          }
      };

    this.commonService.PushSegment(pushSegmentReq).subscribe({next:(responce)=>{
        const data = {
            income_range: this.salarySlab.ammout
        };
        clevertapPush('Segment_Activation_MOD', data);
        this.router.navigateByUrl('/derivative/successfull-request');
        this.btnLoader = false;
      },error:(err)=>{
        this.btnLoader = false;
      }})
    }

  getPushSegment2() {
    //  clientCode + ipAddress +  appSource (UPPER CASE) + incomeSlab
      const parameter = this.userSessionService.getUserSessionData().clientCode +this.userSessionService.getUserSessionData().ip +this.userSessionService.getUserSessionData().appSource.toUpperCase() + this.salarySlab?.values + this.utilService.checkSumDate;
      const pushSegmentReq : PushSegment2Req = {
        ipAddress: this.userSessionService.getUserSessionData().ip,
        appSource: this.userSessionService.getUserSessionData().appSource,
        checkSumValue:this.utilService.GenerateCheckSum(parameter),
        clientCode: this.userSessionService.getUserSessionData().clientCode,
        typeOfModification:'1',
        incomeSlab: this.salarySlab?.values,
        dpAccountNo:  this.dematAccountNo,
        proofCode1:  '22',
        imageProof1: '',
        imageType1:  '',
        proofCode2: '0',
        imageProof2: '',
        imageType2: ''
    };

      this.commonService.PushSegment2(pushSegmentReq).subscribe({next:(responce)=>{
        const data = {
            income_range: this.salarySlab.ammout
        };
        clevertapPush('Segment_Activation_MOD', data);
        this.router.navigateByUrl('/derivative/successfull-request');
        this.btnLoader = false;
      },error:(err)=>{
        this.btnLoader = false;
         const message = err.error.message
                    if (err.error.status == 2 || err.error.httpCode == 422) {
                        this._snackbar.openFromComponent(SnackbarComponent, {
                          data: [message],
                          duration: this.constantService.snackBarDuration,
                          panelClass: ['failed-popup']
                    });
                    this.router.navigateByUrl('/derivative/fail-page');
            }
      }})
  }


  getGetClientModificationStatus() {
      this.btnLoader = true;
      const todayDt = this.datePipe.transform(new Date(), this.constantService.checksumDateFormate);
      const parameter = this.clientCode + this.appSource + this.ipAddress + todayDt;
      const checkSumValue = this.utilService?.GenerateCheckSum(this.appSource, parameter);
      const basicAuth = localStorage.getItem('Authorization');
      const getClientModificationStatusReq: GetClientModificationStatusReq = {
          head: {
              IPAddress: this.ipAddress,
              AppSource: this.appSource,
              ChecksumValue: checkSumValue
          },
          body: {
              clientCode: this.clientCode,
              accountClosureAction: 'A',
              Flag: 1
          }
      };

      this.incomeDetailsService.GetClientModificationStatus(getClientModificationStatusReq).subscribe({next:(response)=>{
        this.btnLoader = false;
        this.dpholding = JSON.parse(response.data.Result.body.Holdings)[0].TotalHolding;
        this.btnText = this.dpholding >= 5000 ? 'Submit' : 'Continue';
      },error:(err)=>{
        this.btnLoader = false;
      }})
  }

  getSalarySlab(event: any) {
      this.errorCheck = false;
      this.salarySlab = this.annualIncomeList[event.value - 1];
  }

  submit() {
      this.btnLoader = true;
      if (this.salarySlab == null || this.salarySlab === undefined) {
          this.btnLoader = false;
          this.errorCheck = true;
          return;
      }
      if (this.dpholding >= 5000) {
          this.getPushSegment2();
      } else {
          clevertapPush('Segment_Activation_MOD', {
              income_slab: this.salarySlab.ammout,
              action: 'MOD_SEG_FIN_MANUAL'
          });
          localStorage.setItem('salarySlab', JSON.stringify(this.salarySlab));
          localStorage.setItem(
              'dematAccountNo',
              this.encryptionService.encryptUsingAES256AndRFC2898(this.dematAccountNo)
          );
          this.router.navigateByUrl('/derivative/proof-selection');
      }
      // this.getUpdateIncomeRange()
     
  }

  async getUpdateIncomeRange(){
      const token = this.cookieService.get('JwtToken');
      const Authorization = 'Bearer '+ token
      const todayDt = this.datePipe.transform(new Date(), this.constantService.checksumDateFormate);
      const parameter = this.clientCode + this.appSource + this.ipAddress + todayDt;
      const checkSumValue = this.utilService?.GenerateCheckSum(this.appSource, parameter);

      const updateIncomeRangeReq : UpdateIncomeRangeReq = {
          "head": {
              "appVer": "1.0",
              "appName": "5P",
              "osName": "WEB",
              "key": environment.salarysegmentKye
          },
          "body": {
              "ClientCode": this.clientCode,
              "IncomeRange": this.salarySlab.values,
              "EmailId": "",
              "EmailConsent": "",
              "Mobile": "",
              "MobileConsent": "",
              "ConsentSource":""
          }
      };

      this.incomeDetailsService.UpdateIncomeRange(updateIncomeRangeReq).subscribe({next:(response)=>{
        try{
            if(response.data.body.status == 0){
                if (this.dpholding >= 5000) {
                    this.getPushSegment2();
                } else {
                    clevertapPush('Segment_Activation_MOD', {
                        income_slab: this.salarySlab.ammout,
                        action: 'MOD_SEG_FIN_MANUAL'
                    });
                    localStorage.setItem('salarySlab', JSON.stringify(this.salarySlab));
                   
                    this.router.navigateByUrl('/derivative/proof-selection');
                   
                }
            }else{
                this.btnLoader = false
            }
           }catch(e){
            this.btnLoader = false
           }
      },error:(err)=>{
        if (err.response.status == 403 || err.response.status == 401) {
            window.location.href = environment.loginUrl
        }else {
            this.btnLoader = false;
        }
      }})
    }


    async segmentDetails() {
        this.btnLoader = true;
        const checksum =  this.userSessionService.getUserSessionData().clientCode + 'PWAWEB' + this.userSessionService.getUserSessionData().ip+this.utilService.checkSumDate      
        
        const segmentDetailsReq:SegmentDetailsReq  = {
        ipAddress:this.userSessionService.getUserSessionData().ip,
        appSource:"PWAWEB",
        checkSumValue: this.utilService.GenerateCheckSum(checksum,'PWAWEB'),
        clientCode:  this.userSessionService.getUserSessionData().clientCode
      };
    this.derivativeDetailsService.segmentDetails(segmentDetailsReq).subscribe({next : (response) => {        
        this.btnLoader = false;
        this.dematAccountNo = response.data.dpAccountNo 
        this.clientStatus = response.data.clientStatus;
        this.dpholding =  response.data.totalHolding;
        this.btnText = this.dpholding >= 5000 ? 'Submit' : 'Continue';
  },error : (err)=>{
  
    
  },})
}


}